import { LinearProgress } from '@mui/material';

function DemandOverviewProgress({ isVisible }) {
  if (!isVisible) return null;

  return <LinearProgress className="sas-progress-bar" />;
}

export default DemandOverviewProgress;
